import { render } from "./SApi.vue?vue&type=template&id=38d9a2df"
import script from "./SApi.vue?vue&type=script&lang=js"
export * from "./SApi.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__